import { userService } from '../services';

export function authHeader() {
    // return authorization header with jwt token
    let user = userService.getUser();

    if (user && user.userId) {
        return { 'HIVE-USER-ID': user.userId };
    } else {
        return {};
    }
}